import React from 'react';
import BooleanRadioField, {
  BooleanRadioFieldProps,
} from '../../BooleanRadioField';
import OfficeExclusiveWrapper from './OfficeExclusiveWrapper';
import { useDelete } from '../hooks/useDelete';
import { useFeatureFlags } from 'src/contexts/FeatureFlagsContext';
import { FeatureFlags } from 'src/flags';

const InternalField: React.FC<BooleanRadioFieldProps> = (props) => {
  const { deleteOfficeExclusiveDocument } = useDelete();

  return (
    <BooleanRadioField
      {...props}
      onDeleteDocument={deleteOfficeExclusiveDocument}
    />
  );
};

const OfficeExclusiveRadioField: React.FC<BooleanRadioFieldProps> = ({
  value,
  onChange,
  disabled = false,
  readOnly = false,
  field,
  fieldLabel,
  error = false,
}) => {
  const { hasFeature } = useFeatureFlags();
  const isMediaV2 = hasFeature(FeatureFlags.NGW_MEDIA_V2);

  if (isMediaV2) {
    return (
      <OfficeExclusiveWrapper>
        <InternalField
          value={value}
          onChange={(value: boolean | null) => onChange(value)}
          disabled={disabled}
          readOnly={readOnly}
          error={error}
          field={field}
          fieldLabel={fieldLabel}
        />
      </OfficeExclusiveWrapper>
    );
  }

  return (
    <BooleanRadioField
      value={value}
      onChange={(value: boolean | null) => onChange(value)}
      disabled={disabled}
      readOnly={readOnly}
      error={error}
      field={field}
      fieldLabel={fieldLabel}
    />
  );
};

export default OfficeExclusiveRadioField;
